import { InsuranceType } from '~/services/api/enums';
import { Gender } from '~/types';
import { IPatientCreateFormValues } from '../types';

const initialValues: IPatientCreateFormValues = {
  programId: null,
  healthCareManagerIds: [],
  subjectId: '',
  firstName: '',
  middleName: '',
  lastName: '',
  phoneNumber: '',
  dateOfBirth: '',
  ethnicity: null,
  dialingNote: '',
  isHomeHealthCare: '0',
  hospitalizationRiskScore: null,
  gender: Gender.Male,
  country: null,
  state: null,
  city: '',
  address: '',
  zip: '',
  comment: '',
  timezone: null,
  bloodPressureDeviceId: null,
  weightScaleDeviceId: null,
  pulseOximeterDeviceId: null,
  bloodGlucoseDeviceId: null,
  attendingPhysicianId: null,
  homePhone: null,
  cellPhone: null,
  workPhone: null,
  shippingAddressSameAsHome: '',
  shippingAddress: '',
  shippingAddressCity: '',
  shippingAddressCountry: null,
  shippingAddressState: null,
  shippingAddressZip: null,
  emergencyContactFirstName: '',
  emergencyContactLastName: '',
  emergencyContactEmail: '',
  emergencyContactPhone: '',
  emergencyContactRelation: null,
  caretakers: [],
  homeHealthcarePeople: [],
  secondaryPhysicians: [],
  insurance: {
    nameId: null,
    groupId: '',
    policyNumber: '',
    type: InsuranceType.Primary,
    plan: null,
    planType: null,
    expiresAt: null,
    isAuthorizationRequired: false,
    authorizationStartDate: null,
    authorizationEndDate: null,
  },
  storageFiles: [],
};

export default initialValues;
